import { NavigationShell } from "./navigation/navigation-shell"
import type { NavigationItem } from "./navigation/navigation-types"

export type PremiumNavItem = {
  label: string
  href: string
  badge?: string
  current?: boolean
}

export type PremiumHeaderProps = {
  brand: string
  navItems?: PremiumNavItem[]
  ctaLabel?: string
  ctaHref?: string
  showSearch?: boolean
  className?: string
}

/** Premium navigation shell with restrained glass, strong spacing, and mobile-safe wrapping. */
export function PremiumHeader({
  brand,
  navItems = [],
  ctaLabel = "Start a project",
  ctaHref = "/contact",
  showSearch = false,
  className,
}: PremiumHeaderProps) {
  return <NavigationShell brand={brand} items={navItems as NavigationItem[]} ctas={[{ label: ctaLabel, href: ctaHref }]} showSearch={showSearch} className={className} />
}
